import { Button, Form, Col, InputGroup, Row, Container } from "react-bootstrap";
import React, {useEffect, useState} from 'react';
import axios from "axios";
import { endpoint } from "../../utils/api";

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus} from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

const Zoom = ({zoom, setZoom}) => {

    const decrement = () => {
        if(zoom > 80){
            updateZoom(zoom-5)
            setZoom(zoom-5);
        }      
    }
    const increment = () => {
        if(zoom < 100){
            updateZoom(zoom+5)
            setZoom(zoom+5);
        }
    }
    
    async function updateZoom(zoom) {
        if (localStorage.token !== undefined && zoom !== undefined) {
         axios({
                method: "put",
                url: `${endpoint}/users/zoom`, 
                data: {
                    zoom_value: zoom
                } ,
                headers: {
                    Authorization: 'Bearer '+ localStorage.token
                }
            })
                .then(function (response) {
            if (response.status === 200) {
       
            } else {
                console.log(response.statusText);
                console.log(response.errors);
            }
            })
            .catch((error) => {
            console.log(error);
            });
        }
    }
   

    return (
        <Row>
                <Col>
                <Button variant="light" className="zoom-button-decrement" onClick={decrement} disabled={zoom === 80}>
                    <FontAwesomeIcon icon={faMinus}  size='1x' className='all-font-icons'/>
                </Button>
                </Col>

                <Col>
                    <p className="zoom-text">{zoom + "%"}</p>
                </Col>

                <Col >            
                <Button variant="light" className="zoom-button" onClick={increment} disabled={zoom === 100}>
                    <FontAwesomeIcon icon={faPlus}  size='1x' className='all-font-icons'/>
                </Button>
                </Col>
            </Row>
    
    )
}


export default Zoom